import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../guards/service/auth.service';
import { DomainService } from '../domain/domain.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const domain = inject(DomainService);

  if (auth.isLoggedIn()) return true;

  const returnUrl = state.url;
  const routeSlug = route.paramMap.get('slug') || '';
  const routeCommunityId = route.paramMap.get('communityId') || '';

  if (domain.isCommunityDomain() && routeSlug && routeCommunityId) {
    return router.createUrlTree([`/${routeSlug}/${routeCommunityId}/login`], { queryParams: { returnUrl } });
  }
  return router.createUrlTree(['/login'], { queryParams: { returnUrl } });
};
